import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Termini e Condizioni</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-sm text-gray-600 mb-6">Ultimo aggiornamento: 17 Gennaio 2026</p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Informazioni Generali</h2>
              <p className="text-gray-700 mb-4">
                Il presente sito web è di proprietà e gestito da:
              </p>
              <p className="text-gray-700 mb-2">
                <strong>SERVICE 360 TOTAL SOLUTIONS LTD</strong><br />
                Partita IVA: BG205967958<br />
                Sede legale: Str. Dr Anastasiya Zhelezkova 35, 9000 Varna, Bulgaria<br />
                Rappresentante Legale: Ugo Filosa<br />
                Email: info@offroaditalia.com<br />
                WhatsApp: +39 379 379 3030
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Accettazione dei Termini</h2>
              <p className="text-gray-700">
                Utilizzando questo sito web e iscrivendoti ai nostri eventi, accetti integralmente i presenti Termini e Condizioni. 
                Se non accetti questi termini, ti preghiamo di non utilizzare il sito.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Servizi Offerti</h2>
              <p className="text-gray-700 mb-4">
                Offroad Italia organizza e gestisce:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Tour offroad in Italia, Tunisia, Libia e altri paesi</li>
                <li>Eventi Enduring</li>
                <li>Rally e navigazione</li>
                <li>Corsi di guida offroad (Offroad University)</li>
                <li>Noleggio moto e attrezzature</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Iscrizione agli Eventi</h2>
              <p className="text-gray-700 mb-4">
                <strong>4.1 Modalità di Iscrizione:</strong> L'iscrizione avviene tramite compilazione del form online o contatto WhatsApp/email.
              </p>
              <p className="text-gray-700 mb-4">
                <strong>4.2 Conferma:</strong> L'iscrizione è considerata valida solo dopo il pagamento del deposito richiesto.
              </p>
              <p className="text-gray-700 mb-4">
                <strong>4.3 Pagamento:</strong>
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Eventi Desert (Tunisia/Libia): Deposito €500 - Saldo 15 giorni prima della partenza</li>
                <li>Eventi Enduring/Tour: Deposito 20% - Saldo secondo indicazioni specifiche</li>
                <li>Modalità: Bonifico bancario o carta di credito (SumUp)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Cancellazioni e Rimborsi</h2>
              <p className="text-gray-700 mb-4">
                <strong>5.1 Cancellazione da parte del Partecipante:</strong>
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Più di 60 giorni prima: Rimborso 100% (trattenuta spese amministrative 10%)</li>
                <li>60-30 giorni prima: Rimborso 50%</li>
                <li>Meno di 30 giorni prima: Nessun rimborso</li>
              </ul>
              <p className="text-gray-700 mt-4">
                <strong>5.2 Cancellazione da parte dell'Organizzatore:</strong> In caso di cancellazione per cause di forza maggiore, 
                verrà rimborsato il 100% o proposta data alternativa.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Requisiti dei Partecipanti</h2>
              <p className="text-gray-700 mb-4">
                Per partecipare agli eventi è necessario:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Età minima: 18 anni</li>
                <li>Patente di guida categoria A valida</li>
                <li>Esperienza di guida offroad (per eventi tecnici)</li>
                <li>Passaporto valido (per eventi internazionali)</li>
                <li>Assicurazione RC Moto</li>
                <li>Condizioni fisiche adeguate all'attività</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Responsabilità</h2>
              <p className="text-gray-700 mb-4">
                <strong>7.1 Limiti di Responsabilità:</strong> Offroad Italia declina ogni responsabilità per:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Danni a persone o cose derivanti da comportamenti imprudenti dei partecipanti</li>
                <li>Furto o smarrimento di oggetti personali</li>
                <li>Incidenti derivanti da mancato rispetto delle regole di sicurezza</li>
                <li>Eventi di forza maggiore (condizioni meteo, situazioni politiche, pandemie)</li>
              </ul>
              <p className="text-gray-700 mt-4">
                <strong>7.2 Assicurazione:</strong> È fortemente consigliata una polizza assicurativa personale per infortuni e spese mediche.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Noleggio Moto</h2>
              <p className="text-gray-700 mb-4">
                In caso di noleggio moto:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>La moto deve essere riconsegnata nelle stesse condizioni</li>
                <li>Eventuali danni saranno addebitati al partecipante</li>
                <li>È prevista una franchigia per danni (specificata nel contratto)</li>
                <li>La manutenzione ordinaria è inclusa</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Comportamento dei Partecipanti</h2>
              <p className="text-gray-700 mb-4">
                I partecipanti si impegnano a:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Rispettare le indicazioni delle guide</li>
                <li>Mantenere un comportamento rispettoso verso gli altri partecipanti</li>
                <li>Rispettare l'ambiente e le comunità locali</li>
                <li>Non guidare sotto effetto di alcol o sostanze</li>
              </ul>
              <p className="text-gray-700 mt-4">
                L'organizzatore si riserva il diritto di escludere dall'evento chi non rispetta queste regole, senza diritto a rimborso.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Proprietà Intellettuale</h2>
              <p className="text-gray-700">
                Tutti i contenuti del sito (testi, immagini, loghi, video) sono di proprietà di SERVICE 360 TOTAL SOLUTIONS LTD o dei rispettivi 
                titolari e sono protetti dalle leggi sul copyright. È vietata la riproduzione senza autorizzazione scritta.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Privacy</h2>
              <p className="text-gray-700">
                Il trattamento dei dati personali è regolato dalla nostra <Link to="/privacy-policy" className="text-blue-600 hover:text-blue-700">Privacy Policy</Link>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Legge Applicabile e Foro Competente</h2>
              <p className="text-gray-700">
                I presenti Termini e Condizioni sono regolati dalla legge bulgara. Per qualsiasi controversia, è competente il foro di Varna, Bulgaria.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Modifiche</h2>
              <p className="text-gray-700">
                Ci riserviamo il diritto di modificare questi Termini in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">14. Contatti</h2>
              <p className="text-gray-700">
                Per domande sui Termini e Condizioni:<br />
                Email: <a href="mailto:info@offroaditalia.com" className="text-blue-600 hover:text-blue-700">info@offroaditalia.com</a><br />
                WhatsApp: <a href="https://wa.me/393793793030?text=Ciao%2C%20vorrei%20informazioni%20sugli%20eventi%20Offroad%20Italia" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700">+39 379 379 3030</a>
              </p>
            </section>
          </div>

          <div className="mt-8 pt-8 border-t">
            <Link to="/" className="text-blue-600 hover:text-blue-700 font-semibold">
              ← Torna alla Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;